import { Typography } from "@mui/material";
import React from "react";

const Typo = (props) => {
  return (
    <Typography
      level={props.level}
      sx={props.style}
      {...props}
      data-testid={props.testId ? props.testId : ""}
    >
      {props.text}
    </Typography>
  );
};

export default Typo;
